import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Rx";
import { Subject } from "rxjs/Subject";
import Amplify, { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "aws-amplify/lib/API/types";
// import aws_exports from '../../../../awsmobilejs/#current-backend-info/aws-exports';
import "rxjs/add/operator/toPromise";
import "rxjs/add/operator/map";
import { Users } from "../../models/users";
import { TripMaster } from "../../models/TripMaster";
import { DriverTripDetailsModel } from "../../models/driverTripDetails";
import { AppConstants } from "../../constants/app-constants";
import { promise } from "protractor";
import { HttpClient, HttpParams } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { TableConstants } from "../../constants/table-constants";
import { HttpUtilsService } from "../../service/httputils.service";
var CryptoJS = require("crypto-js");

// let myAppConfig = {
//   'aws_appsync_graphqlEndpoint': 'https://f333bltb3rer7bjsup4cioi6h4.appsync-api.ap-south-1.amazonaws.com/graphql',
//   'aws_appsync_region': 'ap-south-1',
//   'aws_appsync_authenticationType': 'API_KEY',
//   'aws_appsync_apiKey': 'da2-in3qxoxirzfihj2x7r54sldjx4',
// }
// let myAppConfig = {
//   // ...
//   'aws_appsync_graphqlEndpoint': 'https://7wogkpocife2tdyq2be7emufne.appsync-api.ap-south-1.amazonaws.com/graphql',
//   'aws_appsync_region': 'ap-south-1',
//   'aws_appsync_authenticationType': 'API_KEY',
//   'aws_appsync_apiKey': 'da2-ykjhe43tpnfdlhhtn7trar2vze',
// }
// let myAppConfig = {
//   // ...
//   'aws_appsync_graphqlEndpoint': 'https://t5ttpnldwjbgronm5544cw5dpa.appsync-api.ap-south-1.amazonaws.com/graphql',
//   'aws_appsync_region': 'ap-south-1',
//   'aws_appsync_authenticationType': 'API_KEY',
//   'aws_appsync_apiKey': 'da2-wlmgdmv4rjcjtkmrs46ptp5g64',
// }

// Production
// let myAppConfig = {
//   // ...
//   'aws_appsync_graphqlEndpoint': 'https://kufslz7ccfddlhnyj7fbngmozi.appsync-api.ap-south-1.amazonaws.com/graphql',
//   'aws_appsync_region': 'ap-south-1',
//   'aws_appsync_authenticationType': 'API_KEY',
//   'aws_appsync_apiKey': 'da2-xej2cau5jvdw5dqrqsozfpdknq'
// }

// Stagginh
// let myAppConfig = {
//   aws_appsync_graphqlEndpoint:
//     "https://w4tjgxrxvnguldsclbiqylytm4.appsync-api.ap-south-1.amazonaws.com/graphql",
//   aws_appsync_region: "ap-south-1",
//   aws_appsync_authenticationType: "API_KEY",
//   aws_appsync_apiKey: "da2-qcuqmnkwyrev7pxws67x7gkh7a"
// };

let myAppConfig = environment.myAppConfig;
let url = environment.pg_dburl[window.location.origin];

Amplify.configure(myAppConfig);

@Injectable()
export class AwsService {
  public userTrips: [any];
  public userDetail: {};
  public route_trips: [any];
  public positionsUpdate = new Subject<[Object]>();
  public positionsUpdate$ = this.positionsUpdate.asObservable();
  constructor(
    private httpClient: HttpClient,
    private httpUtils: HttpUtilsService
  ) { }
  createTripPosition() { }

  RncUsersAll(): Promise<any> {
    const tablename = TableConstants.RncUsers;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }
  RncUsersAllNextToken(offset: number, limit: number): Promise<any> {
    const tablename = TableConstants.RncUsers;
    const endpoint = `${url}/${tablename}?offset=${offset}&limit=${limit}`;
    return this.httpUtils.get(endpoint);
  }
  LoginRncUser(user_name: String): Promise<any> {
    const tablename = TableConstants.RncUsers;
    const endpoint = `${url}/${tablename}?data->>user_name=eq.${user_name}`;
    return this.httpUtils.get(endpoint);
  }

  findUserById(id: String): Promise<any> {
    const tablename = TableConstants.RncUsers;
    const endpoint = `${url}/${tablename}?id=eq.${id}`;
    return this.httpUtils.get(endpoint);
  }

  findUserByUserName(user_name: String): Promise<any> {
    const tablename = TableConstants.RncUsers;
    const endpoint = `${url}/${tablename}?data->>user_name=eq.${user_name}`;
    return this.httpUtils.get(endpoint);
  }

  // getRncUsers(id): Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var that = this;
  //     var myPromise = API.graphql(
  //       graphqlOperation(AppConstants.GetRncUserLocationById, { id: id })
  //     ) as Promise<GraphQLResult>;
  //     myPromise
  //       .then((result) => {
  //         //  console.log(AppConstants.list + AppConstants.env + AppConstants.RncUsers)
  //         resolve(
  //           result.data[
  //             AppConstants.getq + AppConstants.env + AppConstants.RncUsers
  //           ]
  //         );
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         reject(error);
  //       });
  //   });
  //   return promise;
  // }

  //FindUserHome Location
  getRncUsersLocation(id): Promise<any> {
    const tablename = TableConstants.RncUsers;
    const endpoint = `${url}/${tablename}?id=eq.${id}`;
    return this.httpUtils.get(endpoint);
  }

  getMetaData(): Promise<any> {
    const tablename = TableConstants.ScMetaData;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  getRncUsersByType(user_type: number): Promise<any> {
    const tablename = TableConstants.RncUsers;
    const endpoint = `${url}/${tablename}?data->>user_type=eq.${user_type}`;
    return this.httpUtils.get(endpoint);
  }
  getRncUsersByTypeByToken(user_type: number): Promise<any> {
    const tablename = TableConstants.RncUsers;
    const endpoint = `${url}/${tablename}?data->>user_type=eq.${user_type}`;
    return this.httpUtils.get(endpoint);
  }

  getRncUsersByTypeByNextToken(user_type: number): Promise<any> {
    const tablename = TableConstants.RncUsers;
    const endpoint = `${url}/${tablename}?data->>user_type=eq.${user_type}`;
    return this.httpUtils.get(endpoint);
  }

  getDriverVehcile(driver_id: String): Promise<any> {
    const tablename = TableConstants.DaVehicleMaster;
    const endpoint = `${url}/${tablename}?driver_id=eq.${driver_id}`;
    return this.httpUtils.get(endpoint);
  }

  updateVehicleMasterlimit(
    id: number,
    office_lat: number,
    office_long: number
  ): Promise<boolean> {
    const functionName = TableConstants.fnUpdateVehicleMasterGeoFenceLimit;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: id,
      updates: {
        office_address: {
          elat: office_lat,
          elong: office_long,
          address: "RNTBCI",
        },
        updated_at: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils
      .post(endpoint, payload)
      .then((response) => !!response);
  }

  // update wellness date

  updateWellnessFeedback(
    id: number,
    feedback_month: string,
    feedback_date: string
  ): Promise<any> {
    const functionName = TableConstants.fnUpdateWellnessFeedback;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: id,
      updates: {
        feedback_month: feedback_month,
        feedback_date: feedback_date,
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  encryptLatLong(
    id,
    home_lat,
    home_long,
    office_lat,
    office_long
  ): Promise<any> {
    // encryptLatLong(id,ph): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      let dateFormat = require("dateformat");
      let now = new Date();
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.encrypt, {
          id: id,
          //  user_phone_number : ph
          // office_address: {
          //   lat: office_lat,
          //   long: office_long
          //   //address: "RNTBCI"
          // },
          // home_address: {
          //   lat: home_lat,
          //   long: home_long
          //   //address: "RNTBCI"
          // }

          office_address: {
            elat: office_lat,
            elong: office_long,
            address: "RNTBCI",
          },
          home_address: {
            elat: home_lat,
            elong: home_long,
            address: "HOME",
          },
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.DaVehicleMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  // encryptLatLong(id,home_lat,home_long,office_lat,office_long): Promise<any> {

  updaterm(
    id,
    s_address,
    e_address,
    os_address,
    oe_address,
    s_date,
    e_date,
    os_date,
    oe_date
  ): Promise<boolean> {
    const functionName = TableConstants.fnUpdateRmTrip;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: id,
      updates: {
        duty_start: {
          address: s_address,
          date_time: s_date,
        },
        duty_end: {
          address: e_address,
          date_time: e_date,
        },
        outstation_duty_start: {
          address: os_address,
          date_time: os_date,
        },
        outstation_duty_end: {
          address: oe_address,
          date_time: oe_date,
        },
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils
      .post(endpoint, payload)
      .then((response) => !!response);
  }

  updateVehicleMaster(vhclmst): Promise<boolean> {
    const functionName = TableConstants.fnUpdateVehicleMaster;
    const endpoint = `${url}/${functionName}`;

    let hlat = CryptoJS.AES.encrypt(
      vhclmst.home_lat.toString(),
      AppConstants.cryptoKey
    ).toString();
    let hlong = CryptoJS.AES.encrypt(
      vhclmst.home_long.toString(),
      AppConstants.cryptoKey
    ).toString();
    let olat = CryptoJS.AES.encrypt(
      vhclmst.office_lat.toString(),
      AppConstants.cryptoKey
    ).toString();
    let olong = CryptoJS.AES.encrypt(
      vhclmst.office_long.toString(),
      AppConstants.cryptoKey
    ).toString();
    let ph = CryptoJS.AES.encrypt(
      vhclmst.user_phone_number.toString(),
      AppConstants.cryptoKey
    ).toString();
    let home = vhclmst.home_address;
    let off = vhclmst.office_address;
    const payload = {
      p_id: vhclmst.id,
      p_driver_id: vhclmst.driver_id,
      updates: {
        driver_id: vhclmst.driver_id,
        vehicle_no: vhclmst.vehicle_no,
        user_name: vhclmst.user_name,
        vehicle_model: vhclmst.vehicle_model,
        geofence_limit: vhclmst.geofence_limit,
        user_phone_number: ph,
        notification_flag: vhclmst.notification_flag,
        agency_type: vhclmst.agency_type,
        driver_type: vhclmst.driver_type,
        ex_data: vhclmst.ex_data,
        home_address: {
          elat: hlat,
          elong: hlong,
          address: home,
        },
        office_address: {
          elat: olat,
          elong: olong,
          address: off,
        },
        updated_at: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };

    return this.httpUtils
      .post(endpoint, payload)
      .then((response) => !!response);
  }
  // updateVehicleMstStatus(id, status): Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var that = this;
  //     var myPromise = API.graphql(graphqlOperation(AppConstants.updateVehicleMstStatus, {
  //       id: id,
  //       status: status
  //     })) as Promise<GraphQLResult>
  //     myPromise.then(result => {
  //       resolve(result.data["updateVehicleMaster"])
  //     }).catch(error => {
  //       console.log(error)
  //       reject(error)
  //     })
  //   });
  //   return promise;
  // }

  createVehicleMst(vhclmst): Promise<any> {
    const tablename = TableConstants.DaVehicleMaster;
    const endpoint = `${url}/${tablename}`;

    let hlat = CryptoJS.AES.encrypt(
      vhclmst.home_lat.toString(),
      AppConstants.cryptoKey
    ).toString();
    let hlong = CryptoJS.AES.encrypt(
      vhclmst.home_long.toString(),
      AppConstants.cryptoKey
    ).toString();
    let olat = CryptoJS.AES.encrypt(
      vhclmst.office_lat.toString(),
      AppConstants.cryptoKey
    ).toString();
    let olong = CryptoJS.AES.encrypt(
      vhclmst.office_long.toString(),
      AppConstants.cryptoKey
    ).toString();
    let ph = CryptoJS.AES.encrypt(
      vhclmst.user_phone_number.toString(),
      AppConstants.cryptoKey
    ).toString();

    const payload = {
      driver_id: vhclmst.driver_id,
      data: {
        driver_id: vhclmst.driver_id,
        vehicle_no: vhclmst.vehicle_no,
        user_id: vhclmst.user_id,
        user_name: vhclmst.user_name,
        status: 0,
        ex_data: "ASSIGN",
        vehicle_model: vhclmst.vehicle_model,
        geofence_limit: vhclmst.geofence_limit,
        user_phone_number: ph,
        notification_flag: vhclmst.notification_flag,
        agency_type: vhclmst.agency_type,
        driver_type: vhclmst.driver_type,
        home_address: {
          elat: hlat,
          elong: hlong,
          address: vhclmst.home_address,
        },
        office_address: {
          elat: olat,
          elong: olong,
          address: vhclmst.office_address,
        },
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      },
      created_date: new Date().toISOString(),
      updated_date: new Date().toISOString(),
    };

    return this.httpUtils.post(endpoint, payload);
  }

  // getTripPositionAllDetails(): Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var that = this;
  //     var myPromise = API.graphql(graphqlOperation(AppConstants.GetTripPositionAllDetails, { first: 20 })) as Promise<GraphQLResult>
  //     myPromise.then(result => {
  //       resolve(result.data["listTripPositionDetails"].items)
  //     }).catch(error => {
  //       console.log(error)
  //       reject(error)
  //     })
  //   });
  //   return promise;
  // }

  //Get Cab Master by vehicle no and Driver Id
  getScCabMaster(driver_id: String, vehicle_no: String): Promise<any> {
    const tablename = TableConstants.ScCabMaster;
    const endpoint = `${url}/${tablename}?driver_id=eq.${driver_id}&data->>vehicle_no=eq.${vehicle_no}`;
    return this.httpUtils.get(endpoint);
  }
  getScCabMasterAll(): Promise<any> {
    const tablename = TableConstants.ScCabMaster;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }
  getScCabMasterById(cab_id: String): Promise<any> {
    if (cab_id !== null) {
      const tablename = TableConstants.ScCabMaster;
      const endpoint = `${url}/${tablename}?id=eq.${cab_id}`;
      return this.httpUtils.get(endpoint);
    } else {
      // Return a rejected promise if cab_id is null or undefined
      console.log("Invalid cab_id - null or undefined provided");
      return Promise.resolve([]);
    }
  }
  getScCabMasterByIds(ids: string[]): Promise<any[]> {
    if (Array.isArray(ids) && ids.length > 0) {
      const tablename = TableConstants.ScCabMaster;
      const idList = ids.map(encodeURIComponent).join(',');
      const endpoint = `${url}/${tablename}?id=in.(${idList})`;
      return this.httpUtils.get(endpoint);
    } else {
      console.log("Invalid ids array provided to getScCabMasterByIds");
      return Promise.resolve([]);
    }
  }
  // getScUserTriprById(id: String): Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var that = this;
  //     var myPromise = API.graphql(graphqlOperation(AppConstants.GetScUserTriprById, { id: id })) as Promise<GraphQLResult>
  //     myPromise.then(result => {
  //       // alert(result)
  //       resolve(result.data[AppConstants.getq + AppConstants.env + AppConstants.ScUserTrip])
  //     }).catch(error => {
  //       console.log(error)
  //       reject(error)
  //     })
  //   });
  //   return promise;
  // }

  // updateVehicleMaster(vhclmst): Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var that = this;
  //     var myPromise = API.graphql(graphqlOperation(AppConstants.UpdateVehicleMaster, {
  //       id: vhclmst.id,
  //       cab_id: vhclmst.driver_id,
  //       scheduled_date: vhclmst.vehicle_no,
  //       user_id: vhclmst.user_ipin,
  //       user_name: vhclmst.user_name,
  //       vehicle_model: vhclmst.vehicle_model,
  //       geofence_limit: vhclmst.geofence_limit,
  //     })) as Promise<GraphQLResult>
  //     myPromise.then(result => {
  //       resolve(result.data["updateVehicleMaster"])
  //     }).catch(error => {
  //       console.log(error)
  //       reject(error)
  //     })
  //   });
  //   return promise;
  // }
  getScTripMaster(
    driver_id: String,
    cab_id: String,
    trip_type: String,
    scheduled_date: String
  ): Promise<any> {
    const tablename = TableConstants.ScTripMaster;
    const endpoint = `${url}/${tablename}?driver_id=eq.${driver_id}&cab_id=eq.${cab_id}&data->>trip_type=eq.${trip_type}&data->>scheduled_date=eq.${scheduled_date}`;
    return this.httpUtils.get(endpoint);
  }

  getScTripMasterFilter(cab_id: String, scheduled_date: String): Promise<any> {
    const tablename = TableConstants.ScTripMaster;
    let endpoint = `${url}/${tablename}?`;
    const params: string[] = [];

    if (cab_id && cab_id !== "" && scheduled_date && scheduled_date !== "") {
      params.push(`cab_id=eq.${cab_id}`);
      params.push(`data->>scheduled_date=like.*${scheduled_date}*`);
    } else if (cab_id && cab_id !== "") {
      params.push(`cab_id=eq.${cab_id}`);
    } else if (scheduled_date && scheduled_date !== "") {
      params.push(`data->>scheduled_date=like.*${scheduled_date}*`);
    }
    // If neither is provided, fetch all
    endpoint += params.join("&");
    return this.httpUtils.get(endpoint);
  }

  getScTripMasterFilterNextToken(
    cab_id: String,
    scheduled_date: String,
    nexttoken: String
  ): Promise<any> {
    const tablename = TableConstants.ScTripMaster;
    let endpoint = `${url}/${tablename}`;
    const params: string[] = [];

    if (cab_id && cab_id.length != 0 && cab_id !== "") {
      params.push(`cab_id=eq.${cab_id}`);
    }
    if (scheduled_date && scheduled_date !== "") {
      params.push(`data->>scheduled_date=like.*${scheduled_date}*`);
    }
    if (params.length > 0) {
      endpoint += "?" + params.join("&");
    }
    return this.httpUtils.get(endpoint);
  }

  getScTripMasterByDate(scheduled_date: String): Promise<any> {
    const tablename = TableConstants.ScTripMaster;
    const endpoint = `${url}/${tablename}?data->>scheduled_date=like.*${scheduled_date}*`;
    return this.httpUtils.get(endpoint);
  }

  getScTripMasterByDateWithToken(
    scheduled_date: String,
    nextToken: String
  ): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.ListScTripMasterBySchduleWithToken, {
          scheduled_date: scheduled_date,
          nextToken: nextToken,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.list +
            AppConstants.env +
            AppConstants.listScTripMasters
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  getScTripMasterAll(): Promise<any> {
    const tablename = TableConstants.ScTripMaster;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }
  getScTripMasterById(id: String): Promise<any> {
    const tablename = TableConstants.ScTripMaster;
    const endpoint = `${url}/${tablename}?id=eq.${id}`;
    return this.httpUtils.get(endpoint);
  }

  getScSosListAll(): Promise<any> {
    const tablename = TableConstants.ScSos;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  /** CAP 18-10-2019 **/

  /* CAR REQUEST */
  getCarRequestListAll(): Promise<any> {
    const tablename = TableConstants.CpCarRequest;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }
  /* ########################## */

  /* ##################### 2019 HOUSE REQUEST ############# */
  // pageCount, pagenationNextToken

  getCarMaintenanceNextTokenPage(
    nextToken: string,
    limit: number
  ): Promise<any> {
    const tablename = TableConstants.CpCarMaintenance;
    // const endpoint = `${url}/${tablename}?offset=${offset}&limit=${limit}`;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  getCarMaintenanceListAll(): Promise<any> {
    const tablename = TableConstants.CpCarMaintenance;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  UpdateCarMaintenanceData(CarMaintenance): Promise<any> {
    const functionName = TableConstants.fnUpdateCarMaintenanceData;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: CarMaintenance.id,
      updates: {
        comments: CarMaintenance.comments,
        request_status: CarMaintenance.request_status,
        ex_data: CarMaintenance.ex_data,
        sla_date: CarMaintenance.sla_date,
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload).then((response) => {
      return response[0];
    });
  }
  /* ##################### 2019 HOUSE REQUEST ############# */

  /* ##################### 2019 HOUSE REQUEST ############# */
  getHouseRequestListAll(): Promise<any> {
    const tablename = TableConstants.CpHouseRequest;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  UpdateHouseRequestData(houseReqData): Promise<any> {
    const functionName = TableConstants.fnUpdateHouseRequestData;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: houseReqData.id,
      updates: {
        comments: houseReqData.comments,
        request_status: houseReqData.request_status,
        ex_data: houseReqData.ex_data,
        sla_date: houseReqData.sla_date,
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload).then((response) => {
      return response[0];
    });
  }
  /* ##################### 2019 HOUSE REQUEST ############# */

  /* ##################### 2019 HOUSE RELOCATION REQUEST ############# */
  getHouseReLocationListAll(): Promise<any> {
    const tablename = TableConstants.CpHouseRelocation;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  UpdateReHouseRequestData(houseReLocData): Promise<any> {
    const functionName = TableConstants.fnUpdateReHouseRequestData;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: houseReLocData.id,
      updates: {
        comments: houseReLocData.comments,
        request_status: houseReLocData.request_status,
        ex_data: houseReLocData.ex_data,
        sla_date: houseReLocData.sla_date,
        packing_Date: houseReLocData.packing_Date,
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload).then((response) => {
      return response[0];
    });
  }

  vendorIdFilter(id): Promise<any> {
    const tablename = TableConstants.CpVendorDetail;
    const endpoint = `${url}/${tablename}?id=eq.${id}`;
    return this.httpUtils.get(endpoint);
  }

  userHouseFilter(id): Promise<any> {
    const tablename = TableConstants.CpHouseMaster;
    const endpoint = `${url}/${tablename}?id=eq.${id}`;
    return this.httpUtils.get(endpoint);
  }

  singleHouseData(id): Promise<any> {
    const tablename = TableConstants.CpHouseRequest;
    const endpoint = `${url}/${tablename}?id=eq.${id}`;
    return this.httpUtils.get(endpoint);
  }

  singleHouseRelocationData(id): Promise<any> {
    const tablename = TableConstants.CpHouseRelocation;
    const endpoint = `${url}/${tablename}?id=eq.${id}`;
    return this.httpUtils.get(endpoint);
  }

  singleCarData(id): Promise<any> {
    const tablename = TableConstants.CpCarMaintenance;
    const endpoint = `${url}/${tablename}?id=eq.${id}`;
    return this.httpUtils.get(endpoint);
  }
  /* ##################### 2019 HOUSE RELOCATION REQUEST ############# */

  filterCarRecord(carReqData) {
    console.log("FILTER_CAR_DATA", carReqData);
    const tablename = TableConstants.CpVehicleMaster;
    const endpoint = `${url}/${tablename}?id=eq.${carReqData}`;
    return this.httpUtils.get(endpoint);
  }
  /* ############################# */

  UpdateCarRequestData(carReqData): Promise<any> {
    console.log("-------------------", carReqData);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateCarRequestData, {
          id: carReqData.id,
          car_id: carReqData.car_id,
          comments: carReqData.comments,
          request_status: carReqData.request_status,
          car_status: carReqData.car_status,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log("----result-------", result);
          console.log(
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpCarRequest
          );
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpCarRequest
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  /* USER CAR ALLOCATION TO ASSIGN CAR TABLE */
  UpdateUserIdCarMaster(data): Promise<any> {
    console.log("-------------------", data);
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateUserIdCarMaster, {
          id: data.car_id,
          map_user_id: data.id,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          console.log(
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpVehicleMaster
          );
          resolve(
            result.data[
            AppConstants.update +
            AppConstants.env +
            AppConstants.updateCpVehicleMaster
            ]
          );
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }
  getCarfilterList(): Promise<any> {
    const tablename = TableConstants.CpVehicleMaster;
    const endpoint = `${url}/${tablename}?data->>map_user_id=eq.0`;
    return this.httpUtils.get(endpoint);
  }
  /* USER CAR ALLOCATION TO ASSIGN CAR TABLE */
  /* ############### CAR MODULE ##################### */
  getCarListAll(): Promise<any> {
    const tablename = TableConstants.fngetCarListAll;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils
      .get<any[]>(endpoint)
      .then((response) => {
        // Map each row to frontend schema
        const items = response.map((row) => {
          const item = { ...row.vehicle_master };
          item.agency = row.vendor_detail;
          return item;
        });
        return { items };
      });
  }
  UpdateCarData(carData): Promise<any> {
    const functionName = TableConstants.fnUpdateCarData;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: carData.id,
      p_agency_name: carData.agency_name,
      updates: {
        car_model: carData.car_model,
        veh_reg_id: carData.veh_reg_id,
        policy_no: carData.policy_no,
        policy_from: carData.policy_from,
        policy_to: carData.policy_to,
        agency_name: carData.agency_name,
        map_user_id: carData.map_user_id,
        lease_from: carData.lease_from,
        lease_to: carData.lease_to,
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }
  CreateCarData(carData): Promise<any> {
    const tablename = TableConstants.CpVehicleMaster;
    const endpoint = `${url}/${tablename}`;
    const payload = {
      agency_name: carData.agency_name,
      data: {
        car_model: carData.car_model,
        veh_reg_id: carData.veh_reg_id,
        policy_no: carData.policy_no,
        policy_from: carData.policy_from,
        policy_to: carData.policy_to,
        //agency_name: carData.agency_name,
        map_user_id: 0,
        lease_from: carData.lease_from,
        lease_to: carData.lease_to,
        car_type: 0,
        ex_data: "UNASSIGN",
        created_date: new Date().toISOString(),
        updated_date: new Date().toISOString(),
      },
      created_date: new Date().toISOString(),
      updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  deleteCarData(id: String): Promise<any> {
    const tablename = TableConstants.CpVehicleMaster;
    const endpoint = `${url}/${tablename}?id=eq.${id}`;
    return this.httpUtils.delete(endpoint);
  }

  /** CAP 18-10-2019 **/
  /* ############### CAR MODULE ##################### */

  /* ############## CAR ASSIGNED MODULE ################ */
  //nextToken: string, limit: number
  // nextToken: nextToken,
  // limit: limit,
  filterRnCar(): Promise<any> {
    const tablename = TableConstants.CpVehicleMaster;
    const endpoint = `${url}/${tablename}?data->>ex_data=eq.UNASSIGN`;
    return this.httpUtils.get(endpoint);
  }

  filterRnExistCar(rn_id: String): Promise<any> {
    const tablename = TableConstants.CpAssignedCar;
    const endpoint = `${url}/${tablename}?data->>rn_id=eq.${rn_id}&data->>status=eq.ASSIGN`;
    return this.httpUtils.get(endpoint);
  }

  getAssignCarList(): Promise<any> {
    const tablename = TableConstants.CpAssignedCar;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  getCarListFilterAll(): Promise<any> {
    const tablename = TableConstants.CpVehicleMaster;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  CreateAssignCar(carData): Promise<any> {
    const tablename = TableConstants.CpAssignedCar;
    const endpoint = `${url}/${tablename}?select=car_id,data->>'status' as status`;
    const payload = {
      user_pid: carData.user_pid,
      car_id: carData.car_id,
      fuel_card_id: carData.fuel_card_id === "" ? null : carData.fuel_card_id,
      data: {
        user_pid: carData.user_pid,
        rn_id: carData.rn_id,
        //car_id: carData.car_id,
        assigned_date: carData.assigned_date,
        status: carData.status,
        ex_data: carData.ex_data,
        fuel_card_id: carData.fuel_card_id === "" ? null : carData.fuel_card_id,
      },
      created_date: new Date().toISOString(),
      updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload).then((response) => {
      return Array.isArray(response) ? response[0] : response;
    });
  }

  updateAssignCar(carData): Promise<{ car_id: string; status: string }> {
    const functionName = TableConstants.fnUpdateAssignCar;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: carData.id,
      p_car_id: carData.car_id,
      updates: {
        rn_id: carData.rn_id,
        assigned_date: carData.assigned_date,
        end_date: carData.end_date,
        status: carData.status,
        ex_data: carData.car_type,
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload).then((response) => {
      return Array.isArray(response) ? response[0] : response;
    });
  }

  carIdFilter(id): Promise<any> {
    const tablename = TableConstants.CpVehicleMaster;
    const endpoint = `${url}/${tablename}?id=eq.${id}`;
    return this.httpUtils.get(endpoint);
  }

  updateMasterCar(carData): Promise<any> {
    const tablename = TableConstants.fnupdateMasterCar;
    const endpoint = `${url}/${tablename}`;
    const payload = {
      p_id: carData.car_id,
      updates: {
        ex_data: carData.status,
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  updateFuelCardStatus(updateCard): Promise<any> {
    const functionName = TableConstants.fnUpdateFuelCardStatus;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: updateCard.fuel_card_id,
      updates: {
        status: updateCard.status,
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  /* ############## CAR ASSIGNED MODULE ################ */

  /* ############## ASSIGN USER ####################### */

  sendEmailService(data) {
    let basUrl = environment.smsUrl[window.location.origin]
    return this.httpClient.post(basUrl + "assignUserEmail/", { ...data });
  }

  userAssignData(userData): Promise<any> {
    const functionName = TableConstants.fnUpdateCpRnUser;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: userData.id,
      updates: {
        user_name: userData.user_name,
        name: userData.name,
        email: userData.email,
        phone: userData.phone,
        assign_mode: userData.assign_mode,
        status: userData.status,
        ex_data: userData.country,
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  CreateUserAssign(userData): Promise<any> {
    const tablename = TableConstants.CpRnUser;
    const endpoint = `${url}/${tablename}`;
    const payload = {
      data: {
        user_name: userData.user_name,
        name: userData.name,
        email: userData.email,
        phone: userData.phone,
        assign_mode: userData.assign_mode,
        status: userData.status,
        ex_data: userData.country,
        created_date: new Date().toISOString(),
        updated_date: new Date().toISOString(),
      },
      created_date: new Date().toISOString(),
      updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  filterRnUserExist(user_name: String): Promise<any> {
    const tablename = TableConstants.CpRnUser;
    const endpoint = `${url}/${tablename}?data->>user_name=eq.${user_name}`;
    return this.httpUtils.get(endpoint);
  }

  getAssignUserList(): Promise<any> {
    const tablename = TableConstants.CpRnUser;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }
  /* ############## ASSIGN USER ####################### */

  /* ################ ASSIGNED HOUSE ################# */
  assignHomeFilter(rn_id: String): Promise<any> {
    const tablename = TableConstants.CpAssignedHome;
    // Filter by rn_id and status = 'ASSIGN'
    const endpoint = `${url}/${tablename}?data->>rn_id=eq.${rn_id}&data->>status=eq.ASSIGN`;
    return this.httpUtils.get(endpoint);
  }
  rnUserFilter(user_name: String): Promise<any> {
    const tablename = TableConstants.RncUsers;
    const endpoint = `${url}/${tablename}?data->>user_name=eq.${user_name}`;
    return this.httpUtils.get(endpoint);
  }

  CreateAssignHouse(houseData): Promise<any> {
    const tablename = TableConstants.CpAssignedHome;
    const endpoint = `${url}/${tablename}`;
    const payload = {
      home_id: houseData.home_id,
      user_pid: houseData.user_pid,
      data: {
        //user_pid: houseData.user_pid,
        rn_id: houseData.rn_id,
        //home_id: houseData.home_id,
        assigned_date: houseData.assigned_date,
        status: houseData.status,
        ex_data: houseData.ex_data,
      },
      created_date: new Date().toISOString(),
      updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  getAssignHouseList(): Promise<any> {
    const tablename = TableConstants.CpAssignedHome;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  homeIdFilter(id): Promise<any> {
    const tablename = TableConstants.CpHouseMaster;
    const endpoint = `${url}/${tablename}?id=eq.${id}`;
    return this.httpUtils.get(endpoint);
  }

  updateAssignHouse(houseData): Promise<any> {
    const functionName = TableConstants.fnUpdateAssignHouse;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: houseData.id,
      p_home_id: houseData.home_id,
      updates: {
        rn_id: houseData.rn_id,
        home_id: houseData.home_id,
        assigned_date: houseData.assigned_date,
        end_date: houseData.end_date,
        status: houseData.status,
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  updateMasterHouse(houseData): Promise<any> {
    const functionName = TableConstants.fnUpdateMasterHouse;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: houseData.home_id,
      updates: {
        house_exdata: houseData.data.status,
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  /* ################ ASSIGNED HOUSE ################# */

  /* ############### HOUSE MODULE ################### */

  getUnAssignHouseList(): Promise<any> {
    const tablename = TableConstants.CpHouseMaster;
    const endpoint = `${url}/${tablename}?data->>house_exdata=eq.UNASSIGN`;
    return this.httpUtils.get(endpoint);
  }
  getHouseList(): Promise<any> {
    const tablename = TableConstants.CpHouseMaster;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  CreateHouseData(houseData): Promise<any> {
    const tablename = TableConstants.CpHouseMaster;
    const endpoint = `${url}/${tablename}?select=id`;
    const payload = {
      data: {
        house_address: houseData.house_address,
        house_location: houseData.house_location,
        house_city: houseData.house_city,
        house_type: houseData.house_type,
        house_size:
          houseData.house_size === undefined || houseData.house_size === ""
            ? "0"
            : houseData.house_size,
        house_exdata:
          houseData.house_exdata === undefined || houseData.house_exdata === ""
            ? "UNASSIGN"
            : houseData.house_exdata,
        owner_name: houseData.owner_name,
        owner_email: houseData.owner_email,
        owner_phone: houseData.owner_phone,
        owner_address: houseData.owner_address,
        owner_exdata:
          houseData.owner_exdata === undefined || houseData.owner_exdata === ""
            ? "0"
            : houseData.owner_exdata,
        lease_start_date: houseData.lease_start_date,
        lease_end_date: houseData.lease_end_date,
        property_type:
          houseData.property_type === undefined ||
            houseData.property_type === ""
            ? "0"
            : houseData.property_type,
        created_date: new Date().toISOString(),
        updated_date: new Date().toISOString(),
      },
      owner_exdata: houseData.owner_exdata === undefined || houseData.owner_exdata === ""
        ? "0"
        : houseData.owner_exdata,
      created_date: new Date().toISOString(),
      updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload).then((response) => {
      const inserted_id = Array.isArray(response) ? response[0] : response;
      return inserted_id;
    });
  }

  UpdateHouseData(houseData): Promise<any> {
    const functionName = TableConstants.fnUpdateHouseData;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: houseData.id,
      p_owner_exdata: houseData.owner_exdata === undefined || houseData.owner_exdata === ""
        ? "0"
        : houseData.owner_exdata,
      updates: {
        house_address: houseData.house_address,
        house_location: houseData.house_location,
        house_city: houseData.house_city,
        house_type: houseData.house_type,
        house_size:
          houseData.house_size === undefined || houseData.house_size === ""
            ? "0"
            : houseData.house_size,
        owner_name: houseData.owner_name,
        owner_email: houseData.owner_email,
        owner_phone: houseData.owner_phone,
        owner_address: houseData.owner_address,
        owner_exdata:
          houseData.owner_exdata === undefined || houseData.owner_exdata === ""
            ? "0"
            : houseData.owner_exdata,
        lease_start_date: houseData.lease_start_date,
        lease_end_date: houseData.lease_end_date,
        property_type: houseData.property_type,
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  deleteHouseData(id: any): Promise<any> {
    const tablename = TableConstants.CpHouseMaster;
    const endpoint = `${url}/${tablename}?id=eq.${id.id}`;
    return this.httpUtils.delete(endpoint);
  }

  /* ############### HOUSE MODULE ################### */

  /* ############## VENDOR MODULE ################### */
  getVendorlist(): Promise<any> {
    const tablename = TableConstants.CpVendorDetail;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  getActiveVendorlist(): Promise<any> {
    const tablename = TableConstants.CpVendorDetail;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }
  CreateVendorData(vendorData): Promise<any> {
    const tablename = TableConstants.CpVendorDetail;
    const endpoint = `${url}/${tablename}`;
    const payload = {
      data: {
        name: vendorData.name,
        email: vendorData.email,
        phone: vendorData.phone,
        address: vendorData.address,
        vendor_type: vendorData.vendor_type,
        is_active: vendorData.is_active,
        ex_data: vendorData.selectedCountries,
        created_date: new Date().toISOString(),
        updated_date: new Date().toISOString(),
      },
      created_date: new Date().toISOString(),
      updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  UpdateVendorData(vendorData): Promise<any> {
    const tablename = TableConstants.fnUpdateVendorData;
    const endpoint = `${url}/${tablename}`;
    const dataObj = {
      name: vendorData.name,
      email: vendorData.email,
      phone: vendorData.phone,
      address: vendorData.address,
      vendor_type: vendorData.vendor_type,
      is_active: vendorData.is_active,
      ex_data: vendorData.selectedCountries,
      updated_date: new Date().toISOString(),
    };
    const payload = {
      p_id: vendorData.id,
      updates: dataObj,
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  // UpdateVendorData(vendorData): Promise<any> {
  //   // console.log("-------------------", vendorData);
  //   let promise = new Promise((resolve, reject) => {
  //     var that = this;
  //     var dtdata = new Date();
  //     var date_time = dtdata.getDate;
  //     var myPromise = API.graphql(
  //       graphqlOperation(AppConstants.UpdateVendorData, {
  //         id: vendorData.id,
  //         name: vendorData.name,
  //         email: vendorData.email,
  //         phone: vendorData.phone,
  //         address: vendorData.address,
  //         vendor_type: vendorData.vendor_type,
  //         is_active: vendorData.is_active,
  //         ex_data: vendorData.selectedCountries,
  //         updated_date: new Date().toISOString(),
  //       })
  //     ) as Promise<GraphQLResult>;
  //     myPromise
  //       .then((result) => {
  //         console.log("result", result);
  //         resolve(
  //           result.data[
  //           AppConstants.update +
  //           AppConstants.env +
  //           AppConstants.updateCpVendorDetail
  //           ]
  //         );
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         reject(error);
  //       });
  //   });
  //   return promise;
  // }

  deleteVendorData(id: String): Promise<any> {
    const tablename = TableConstants.CpVendorDetail;
    const endpoint = `${url}/${tablename}?id=eq.${id}`;
    return this.httpUtils.delete(endpoint);
  }
  /* ############## VENDOR MODULE ################### */

  // to get wellness app data
  getWelnessData(in_time, to_date): Promise<any> {
    const tablename = TableConstants.AppFitnessFeedback;
    // Filter feedback_date between in_time and to_date
    const endpoint = `${url}/${tablename}?data->>feedback_date=gte.${in_time}&data->>feedback_date=lte.${to_date}`;
    return this.httpUtils.get(endpoint);
  }

  // to get wellness app data
  getWelnessDataMigration(): Promise<any> {
    const tablename = TableConstants.AppFitnessFeedback;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  // to get wellness app data
  getWelnessDataNextTokenMigration(nextToken): Promise<any> {
    const tablename = TableConstants.AppFitnessFeedback;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  // to get wellness app data
  getWelnessDataNextToken(nextToken, in_time, to_date): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;

      var myPromise = API.graphql(
        graphqlOperation(AppConstants.getAppFitnessFeedbackNextToken, {
          nextToken: nextToken,
          in_time: in_time,
          to_date: to_date,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.list +
            AppConstants.env +
            AppConstants.listAppFitnessFeedback
            ]
          );
          console.log("getWelnessDataNextToken", result);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
    return promise;
  }

  getOpenSos(): Promise<any> {
    const tablename = TableConstants.ScSos;
    const endpoint = `${url}/${tablename}?data->>status=eq.0`;
    return this.httpUtils.get(endpoint);
  }
  getScSosList(): Promise<any> {
    const tablename = TableConstants.ScSos;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }
  getScSosMaster(): Promise<any> {
    const tablename = TableConstants.ScSosMaster;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  UpdateScSos(sos): Promise<any> {
    const functionName = TableConstants.fnUpdateScSos;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: sos.id,
      updates: {
        comments: sos.comments,
        status: sos.status,
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }
  UpdateScTripMaster(trip): Promise<any> {
    const functionName = TableConstants.fnUpdateScTripMaster;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: trip.id,
      p_cab_id: trip.cab_id,
      p_driver_id: trip.driver_id,
      updates: {
        //driver_id: trip.driver_id,
        scheduled_date:
          trip.scheduled_date + "T" + trip.scheduled_time + ":00+05:30",
        //cab_id: trip.cab_id,
        status: trip.status,
        trip_type: trip.trip_type,
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  UpdateScUserByTrip(id: number, usertrip: any): Promise<any> {
    const functionName = TableConstants.fnUpdateScUserByTrip;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: id,
      updates: {
        scheduled_date:
          usertrip.scheduled_date + "T" + usertrip.scheduled_time + ":00+05:30",
        trip_type: usertrip.trip_type,
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }
  // updateSos(sos): Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var that = this;
  //     var myPromise = API.graphql(graphqlOperation(AppConstants.UpdateSOS,
  //       {
  //         id: sos.id,
  //         admin_comment: sos.admin_comment
  //       })) as Promise<GraphQLResult>
  //     myPromise.then(result => {
  //       resolve(result.data["UpdateSOS"])
  //     }).catch(error => {
  //       console.log(error)
  //       reject(error)
  //     })
  //   });
  //   return promise;
  // }
  // creaet SC_
  UpdateScUserTrips(usertrip, st, end): Promise<any> {
    const functionName = TableConstants.fnUpdateScUserTrips;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: usertrip.id,
      updates: {
        trip_status: usertrip.trip_status,
        drop_point: usertrip.drop_point,
        otp: usertrip.otp,
        is_boarded: usertrip.is_boarded,
        start_address: {
          lat: st.lat,
          long: st.long,
          address: st.address,
        },
        end_address: {
          lat: end.lat,
          long: end.long,
          address: end.address,
        },
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  UpdateScUserTripsOtp(id): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;

      var myPromise = API.graphql(
        graphqlOperation(AppConstants.UpdateScUserTripsOtp, {
          id: id,
          otp: 123456,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.update + AppConstants.env + AppConstants.ScUserTrip
            ]
          );
        })
        .catch((error) => {
          reject(error);
        });
    });
    return promise;
  }
  // creaet SC_
  updateScUserTrip(id, start, end): Promise<void> {
    const functionName = TableConstants.fnUpdateScUserTrip;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: id,
      updates: {
        start_address: {
          lat: start.lat,
          long: start.long,
          address: start.address,
        },
        end_address: {
          lat: end.lat,
          long: end.long,
          address: end.address,
        },
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }
  createScUserTrip(
    trip_id: string,
    user_id: string,
    trip_type: string,
    drop_point: number,
    scheduled_date: string,
    start: any,
    end: any
  ): Promise<void> {
    const tablename = TableConstants.ScUserTrip;
    const endpoint = `${url}/${tablename}`;
    const payload = {
      trip_id: trip_id,
      user_id: user_id,
      data: {
        trip_status: 0,
        trip_type: trip_type,
        otp: 123456,
        is_boarded: false,
        drop_point: drop_point,
        scheduled_date: scheduled_date,
        start_address: {
          lat: start.lat,
          long: start.long,
          address: start.address,
        },
        end_address: {
          lat: end.lat,
          long: end.long,
          address: end.address,
        },
        created_date: new Date().toISOString(),
        updated_date: new Date().toISOString(),
      },
      created_date: new Date().toISOString(),
      updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  createProdDaTrips(trips: any): Promise<any> {
    const tablename = TableConstants.DaTrips;
    const endpoint = `${url}/${tablename}`;
    const payload = {
      driver_id: trips.driver_id,
      data: {
        created_at: trips.created_at,
        trip_type: trips.trip_type,
        vehicle_no: trips.vehicle_no,
        trip_status: trips.trip_status,
        duty_start: {
          date_time: trips.duty_start_date,
          address: trips.duty_start_address,
        },
        duty_end: {
          date_time: trips.duty_end_date,
          address: trips.duty_end_address,
        },
      },
      created_date: new Date().toISOString(),
      updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  createRnHrbotKeymapsSuggestions(
    context_key: any,
    context_query_val: any,
    context_suggestions: any,
    policy_names: any
  ): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var that = this;
      var myPromise = API.graphql(
        graphqlOperation(AppConstants.CreateRnHrbotKeymapsSuggestions, {
          context_key: context_key,
          context_query_val: context_query_val,
          context_suggestions: context_suggestions,
          policy_names: policy_names,
        })
      ) as Promise<GraphQLResult>;
      myPromise
        .then((result) => {
          resolve(
            result.data[
            AppConstants.create +
            AppConstants.env +
            AppConstants.RnHrbotKeymapsSuggestions
            ]
          );
        })
        .catch((error) => {
          reject(error);
        });
    });
    return promise;
  }

  //migration feedback
  createProdAppFitnessFeedback(feed: any): Promise<any> {
    const tablename = TableConstants.AppFitnessFeedback;
    const endpoint = `${url}/${tablename}`;
    const payload = {
      data: {
        rn_number: feed.rn_number,
        remarks: feed.remarks,
        timestamp: feed.timestamp,
        rating: feed.rating,
        created_date: new Date().toISOString(),
        updated_date: new Date().toISOString(),
      },
      created_date: new Date().toISOString(),
      updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  // create ScTripMaster ,
  createScTripMaster(
    driver_id: string,
    cab_id: string,
    trip_type: string,
    scheduled_date: string
  ): Promise<any> {
    const tablename = TableConstants.ScTripMaster;
    const endpoint = `${url}/${tablename}?select=id`;
    const payload = {
      driver_id: driver_id,
      cab_id: cab_id,
      data: {
        trip_type: trip_type,
        status: 0,
        start_otp: Math.floor(Math.random() * (999999 - 100000)) + 100000,
        end_otp: Math.floor(Math.random() * (999999 - 100000)) + 100000,
        scheduled_date: scheduled_date,
        created_date: new Date().toISOString(),
        updated_date: new Date().toISOString(),
      },
      created_date: new Date().toISOString(),
      updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload).then((response) => {
      return Array.isArray(response) && response.length > 0
        ? response[0]
        : null;
    });
  }
  //cab master insert opertion

  //cab master insert opertion
  createScCabMaster(
    driver_id: string,
    driver_name: string,
    vehicle_no: string
  ): Promise<any> {
    const tablename = TableConstants.ScCabMaster;
    const endpoint = `${url}/${tablename}?select=id`;
    const payload = {
      driver_id: driver_id,
      data: {
        driver_name: driver_name,
        vehicle_no: vehicle_no,
        no_seats: "5",
        created_date: new Date().toISOString(),
        updated_date: new Date().toISOString(),
      },
      created_date: new Date().toISOString(),
      updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload).then((response) => {
      return Array.isArray(response) && response.length > 0
        ? response[0]
        : null;
    });
  }
  //

  // delete if exits id present in UserTrip Table
  deleteScUserTrip(id: String): Promise<any> {
    const tablename = TableConstants.ScUserTrip;
    const endpoint = `${url}/${tablename}?id=eq.${id}`;
    return this.httpUtils.delete(endpoint);
  }
  // deleteVehicleMaster(vehicle_no: String) : Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var myPromise = API.graphql(graphqlOperation(AppConstants.DeleteVehicleMaster, { vehicle_no: vehicle_no })) as Promise<GraphQLResult>
  //     var that = this
  //     myPromise.then(result => {
  //       resolve(result.data["deleteVehicleMaster"]);
  //     }).catch(error => {
  //       console.log(error)
  //       reject(error)
  //     })
  //   });
  //   return promise;
  // }

  deleteDaVehicleMaster(id: String): Promise<any> {
    const tablename = TableConstants.DaVehicleMaster;
    const endpoint = `${url}/${tablename}?id=eq.${id}`;
    return this.httpUtils.delete(endpoint);
  }

  deleteScTripMaster(id: String): Promise<any> {
    const tablename = TableConstants.ScTripMaster;
    const endpoint = `${url}/${tablename}?id=eq.${id}`;
    return this.httpUtils.delete(endpoint);
  }

  // // delete TripMaster Details
  // deleteTripMaster(id: String) : Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var myPromise = API.graphql(graphqlOperation(AppConstants.DeleteTripMaster, { id: id })) as Promise<GraphQLResult>
  //     var that = this
  //     myPromise.then(result => {
  //       resolve(result.data["deleteTripMaster"]);
  //     }).catch(error => {
  //       console.log(error)
  //       reject(error)
  //     })
  //   });
  //   return promise;
  // }

  //create RNC users
  createRncUser(user: any): Promise<any> {
    const tablename = TableConstants.RncUsers;
    const endpoint = `${url}/${tablename}?select=id`;
    const payload = {
      data: {
        user_type: user.user_type,
        name: user.name,
        user_name: user.user_id,
        password: user.password,
        emergency_phone: user.emergency_phone,
        employee_phone: user.employee_phone,
        sos_enabled: 1,
        home_address: user.home_address,
        created_date: new Date().toISOString(),
        updated_date: new Date().toISOString(),
      },
      created_date: new Date().toISOString(),
      updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload).then((response) => {
      return Array.isArray(response) && response.length > 0
        ? response[0].id
        : null;
    });
  }
  //Update User Location
  updateRncUserLocation(
    id: number,
    lat: number,
    long: number,
    address: string
  ): Promise<boolean> {
    const functionName = TableConstants.fnUpdateRncUserLocation;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: id,
      updates: {
        home_address: {
          lat: lat,
          long: long,
          address: address,
        },
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  //Update User Location
  updateRncUserType(id, userType): Promise<boolean> {
    const functionName = TableConstants.fnUpdateRncUserType;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: id,
      updates: {
        user_type: userType,
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  /* 2019 rncuser */
  updateRncUserAssignType(id, userType): Promise<any> {
    const functionName = TableConstants.fnUpdateRncUserAssignType;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: id,
      updates: {
        user_type: userType,
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  //Update User Agency Type for Personal Users
  updatePersonalDriverAgency(
    id: number,
    agency_type: string
  ): Promise<boolean> {
    const functionName = TableConstants.fnUpdatePersonalDriverAgency;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: id,
      updates: {
        agency_type: agency_type,
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils
      .post(endpoint, payload)
      .then((response) => !!response);
  }
  updateRncUsers(user, address): Promise<any> {
    const functionName = TableConstants.fnUpdateRncUsers;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: user.id,
      updates: {
        emergency_phone: "+91" + user.emergency_phone,
        employee_phone: "+91" + user.employee_phone,
        name: user.name,
        user_name: user.user_name,
        user_type: user.user_type,
        sos_enabled: user.sos_enabled,
        home_address: {
          lat: address.lat,
          long: address.long,
          address: user.home_address,
        },
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  updateRncUsersContact(user): Promise<boolean> {
    const functionName = TableConstants.fnUpdateRncUsersContact;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: user.id,
      updates: {
        name: user.name,
        emergency_phone: user.emergency_phone,
        employee_phone: user.employee_phone,
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }
  //get driver trip Details All
  getDriverAttendanceAll(created_at): Promise<any> {
    const tablename = TableConstants.DaTrips;
    // Filter records where created_at >= provided date
    const endpoint = `${url}/${tablename}?data->>created_at=gte.${created_at}`;
    return this.httpUtils.get(endpoint);
  }

  getVehicleMaster(): Promise<any> {
    const tablename = TableConstants.DaVehicleMaster;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  getVehicleMasterByUser(user_id): Promise<any> {
    const tablename = TableConstants.DaVehicleMaster;
    const endpoint = `${url}/${tablename}?data->>user_id=eq.${user_id}`;
    return this.httpUtils.get(endpoint);
  }

  getVehicleMasterByDriver(driver_id): Promise<any> {
    const tablename = TableConstants.DaVehicleMaster;
    const endpoint = `${url}/${tablename}?driver_id=eq.${driver_id}`;
    return this.httpUtils.get(endpoint);
  }

  getVehicleMasterByDriverIDs(ids: string[]): Promise<any[]> {
    if (Array.isArray(ids) && ids.length > 0) {
      const tablename = TableConstants.DaVehicleMaster;
      // Join IDs with commas for the 'in' filter
      const idList = ids.map(encodeURIComponent).join(',');
      const endpoint = `${url}/${tablename}?driver_id=in.(${idList})`;
      return this.httpUtils.get(endpoint);
    } else {
      console.log("Invalid ids array provided to getVehicleMasterByDriverIDs");
      return Promise.resolve([]);
    }
  }
  //get vehicle Master
  // getVehicleMasterAll(searchData): Promise<any> {
  //   let promise = new Promise((resolve, reject) => {
  //     var that = this;
  //     var myPromise = API.graphql(
  //       graphqlOperation(this.getVehicleMstQueryFormation(searchData))
  //     ) as Promise<GraphQLResult>;
  //     myPromise
  //       .then((result) => {
  //         resolve(
  //           result.data[
  //             AppConstants.list +
  //               AppConstants.env +
  //               AppConstants.listDaVehicleMasters
  //           ].items
  //         );
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         reject(error);
  //       });
  //   });
  //   return promise;
  // }

  // getVehicleMstQueryFormation(searchFilter) {
  //   let filterstr = "";
  //   //console.log(searchFilter)
  //   if (searchFilter.driver_id != "") {
  //     filterstr = filterstr.concat(
  //       filterstr,
  //       AppConstants.driverIDFilterCons +
  //         searchFilter.driver_id +
  //         AppConstants.filterend
  //     );
  //   }
  //   if (searchFilter.vehicle_no != "") {
  //     filterstr = filterstr.concat(
  //       filterstr,
  //       AppConstants.vehicleNoFilterCons +
  //         searchFilter.vehicle_no +
  //         AppConstants.filterend
  //     );
  //   }
  //   if (searchFilter.user_name != "") {
  //     filterstr = filterstr.concat(
  //       filterstr,
  //       AppConstants.userNameFilterCons +
  //         searchFilter.user_name +
  //         AppConstants.filterend
  //     );
  //   }
  //   if (searchFilter.agency_type != "") {
  //     filterstr = filterstr.concat(
  //       filterstr,
  //       AppConstants.agencyTypeFilterCons +
  //         searchFilter.agency_type +
  //         AppConstants.filterend
  //     );
  //   }
  //   let query = "";
  //   if (filterstr == "") {
  //     query = AppConstants.ListDaVehicleMasters;
  //   } else {
  //     query =
  //       `query ` +
  //       AppConstants.list +
  //       AppConstants.env +
  //       AppConstants.listDaVehicleMasters +
  //       `
  //     {
  //       ` +
  //       AppConstants.list +
  //       AppConstants.env +
  //       AppConstants.listDaVehicleMasters +
  //       ` (filter: {` +
  //       filterstr +
  //       `})` +
  //       AppConstants.listDaVehicleMastersItems +
  //       `}`;
  //   }

  //   console.log("11111111", query);
  //   return query;
  // }

  getVehicleMasterAll(searchData: any): Promise<any> {
    const tablename = TableConstants.fngetDaVehicleMasterAll;
    let params: string[] = [];

    if (
      searchData.driver_id &&
      searchData.driver_id !== "" &&
      searchData.driver_id !== undefined
    ) {
      params.push(
        `p_driver_id={${searchData.driver_id
          .map(encodeURIComponent)
          .join(",")}}`
      );
    }
    if (
      searchData.vehicle_no &&
      searchData.vehicle_no !== "" &&
      searchData.vehicle_no !== undefined
    ) {
      params.push(`p_vehicle_no=${searchData.vehicle_no}`);
    }
    if (
      searchData.user_name &&
      searchData.user_name !== "" &&
      searchData.user_name !== undefined
    ) {
      params.push(`p_user_name=${searchData.user_name}`);
    }
    if (
      searchData.agency_type &&
      searchData.agency_type !== "" &&
      searchData.agency_type !== undefined &&
      searchData.agency_type != 0
    ) {
      params.push(`p_agency_type=${searchData.agency_type}`);
    }

    const endpoint = `${url}/${tablename}${params.length ? "?" + params.join("&") : ""
      }`;
    return this.httpUtils
      .get<any[]>(endpoint)
      .then((response) => {
        // Map each row to frontend schema
        const items = response.map((row) => {
          const item = { ...row.vehicle_master };
          item.driver = row.rnc_users;
          return item;
        });
        return { items };
      });
  }

  // getVehicleMstQueryFormation(searchFilter) {
  //   let filterstr = "";
  //   //console.log(searchFilter)
  //   if (searchFilter.driver_id != "") {
  //     filterstr = "driver_id : { in: " +
  //       JSON.stringify(searchFilter.driver_id) + "}";
  //     console.log(JSON.parse(JSON.stringify(filterstr)), "filterstr::::::::::::::::");

  //   }
  //   if (searchFilter.vehicle_no != "") {
  //     const vehicle_no = AppConstants.vehicleNoFilterCons +
  //       searchFilter.vehicle_no +
  //       AppConstants.filterend;
  //     filterstr = filterstr + vehicle_no;
  //   }
  //   if (searchFilter.user_name != "") {
  //     const user_name = AppConstants.userNameFilterCons +
  //       searchFilter.user_name + AppConstants.filterend;
  //     filterstr = filterstr + user_name;
  //   }
  //   if (searchFilter.agency_type != "") {
  //     const agency_type = AppConstants.agencyTypeFilterCons +
  //       searchFilter.agency_type +
  //       AppConstants.filterend;
  //     filterstr = filterstr + agency_type;
  //   }
  //   let query = "";
  //   if (filterstr == "") {
  //     query = AppConstants.ListDaVehicleMasters;
  //   } else {
  //     query =
  //       `query ` +
  //       AppConstants.list +
  //       AppConstants.env +
  //       AppConstants.listDaVehicleMasters +
  //       `
  //     {
  //       ` +
  //       AppConstants.list +
  //       AppConstants.env +
  //       AppConstants.listDaVehicleMasters +
  //       ` (filter: {` +
  //       filterstr +
  //       `})` +
  //       AppConstants.listDaVehicleMastersItems +
  //       `}`;
  //   }

  //   console.log("11111111", query);
  //   return query;
  // }

  ScUserTripFilter(searchFilter: any, nextToken) {
    const tablename = TableConstants.ScUserTrip;
    let endpoint = `${url}/${tablename}?`;
    const params: string[] = [];

    if (searchFilter.scheduled_date && searchFilter.scheduled_date !== "") {
      params.push(
        `data->>scheduled_date=like.*${searchFilter.scheduled_date}*`
      );
    }
    if (searchFilter.user_id && searchFilter.user_id !== "") {
      params.push(`user_id=eq.${searchFilter.user_id}`);
    }
    if (searchFilter.trip_type && searchFilter.trip_type !== "") {
      params.push(`data->>trip_type=eq.${searchFilter.trip_type}`);
    }
    if (searchFilter.trip_status && searchFilter.trip_status !== "") {
      params.push(`data->>trip_status=eq.${searchFilter.trip_status}`);
    }

    endpoint += params.join("&");
    return this.httpUtils.get(endpoint);
  }

  driverAttendanceFilter(searchFilter: any) {
    const tablename = TableConstants.DaTrips;
    let endpoint = `${url}/${tablename}?`;
    const params: string[] = [];

    if (searchFilter.drivers && searchFilter.drivers.length > 0) {
      params.push(`driver_id=eq.${searchFilter.drivers[0].id}`);
    }
    if (searchFilter.vehicles && searchFilter.vehicles.length > 0) {
      params.push(`data->>vehicle_no=eq.${searchFilter.vehicles[0]}`);
    }
    if (
      searchFilter.dutyStart &&
      searchFilter.dutyStart !== "" &&
      searchFilter.dutyEnd &&
      searchFilter.dutyEnd !== ""
    ) {
      params.push(`data->>created_at=gte.${searchFilter.dutyStart}`);
      params.push(`data->>created_at=lte.${searchFilter.dutyEnd}`);
    } else if (searchFilter.dutyStart == "" && searchFilter.dutyEnd != "") {
      params.push(`data->>created_at=gte.${searchFilter.dutyStart}`);
    } else if (searchFilter.dutyStart == "" && searchFilter.dutyEnd != "") {
      params.push(`data->>created_at=lte.${searchFilter.dutyEnd}`);
    }
    if (searchFilter.outStation && searchFilter.outStation !== "") {
      params.push(`data->>trip_type=eq.${searchFilter.outStation}`);
    }

    // params.push(`offset=${offset}`);
    // params.push(`limit=${limit}`);

    endpoint += params.join("&");
    return this.httpUtils.get(endpoint);
  }
  // private handleError(error: any) {
  //   let errMsg = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
  //   return Observable.throw(error);
  // }
  handleError(error: any) {
    let errormsg = error.errors;
    errormsg.forEach((element) => {
      return Observable.throw(element.message);
    });
  }
  // trip position
  getScTripPosition(trip_id): Promise<any> {
    const tablename = TableConstants.ScTripPosition;
    const endpoint = `${url}/${tablename}?data->>trip_id=eq.${trip_id}`;
    return this.httpUtils.get(endpoint);
  }
  //Finished Trip Screen services------------------------------------------------------------------------------
  getTripsByStatus(status, lecondition, gecondition) {
    console.log("lecondition", lecondition);
    console.log("gecondition", gecondition);
    const tablename = TableConstants.ScTripMaster;
    // status: 2 = completed, else remaining
    let endpoint = `${url}/${tablename}?data->>status=eq.${status}`;
    if (lecondition) {
      endpoint += `&data->>scheduled_date=lte.${lecondition}`;
    }
    if (gecondition) {
      endpoint += `&data->>scheduled_date=gte.${gecondition}`;
    }
    return this.httpUtils.get(endpoint);
  }

  getTripsByStatusNextToken(status, lecondition, gecondition, nexttoken) {
    // status = '1';
    // lecondition = '2019-10-14';
    // gecondition = ''; // testing
    console.log("lecondition", lecondition);
    console.log("gecondition", gecondition);
    const tablename = TableConstants.ScTripMaster;
    let endpoint = `${url}/${tablename}?data->>status=eq.${status}`;
    if (lecondition) {
      endpoint += `&data->>scheduled_date=lte.${lecondition}`;
    }
    if (gecondition) {
      endpoint += `&data->>scheduled_date=gte.${gecondition}`;
    }
    // if (nexttoken != null) {
    //   endpoint += `&offset=${nexttoken}`;
    // }
    //endpoint += `&limit=100`;
    return this.httpUtils.get(endpoint);
  }

  //
  getTripsByStatusCnt(status, scheduled_date) {
    const tablename = TableConstants.ScTripMaster;
    // For completed trips (status == 2), use 'lte' (less than or equal), else use 'gte' (greater than or equal)
    let endpoint = "";
    if (status == 2) {
      endpoint = `${url}/${tablename}?data->>status=eq.${status}&data->>scheduled_date=lte.${scheduled_date}`;
    } else {
      endpoint = `${url}/${tablename}?data->>status=eq.${status}&data->>scheduled_date=gte.${scheduled_date}`;
    }
    return this.httpUtils.get(endpoint);
  }
  getCurrentDayTrip(today) {
    const tablename = TableConstants.ScTripMaster;
    const endpoint = `${url}/${tablename}?data->>scheduled_date=like.*${today}*`;
    return this.httpUtils.get(endpoint);
  }

  getCurrentDayTripNextToken(today, nexttoken) {
    const tablename = TableConstants.ScTripMaster;
    var endpoint = `${url}/${tablename}?data->>scheduled_date=like.*${today}*`;
    if (nexttoken) {
      endpoint += `&nextToken=${encodeURIComponent(nexttoken)}`;
    }
    return this.httpUtils.get(endpoint);

    // let promise = new Promise((resolve, reject) => {
    //   var that = this;
    //   var myPromise = API.graphql(
    //     graphqlOperation(AppConstants.GetCurrentDayTripNextToken, {
    //       today: today,
    //       nextToken: nexttoken,
    //     })
    //   ) as Promise<GraphQLResult>;
    //   myPromise
    //     .then((result) => {
    //       let data = { items: {}, nextToken: String };
    //       data.items =
    //         result.data[
    //           AppConstants.list +
    //           AppConstants.env +
    //           AppConstants.listScTripMasters
    //         ].items;
    //       data.nextToken =
    //         result.data[
    //           AppConstants.list +
    //           AppConstants.env +
    //           AppConstants.listScTripMasters
    //         ].nextToken;

    //       resolve(data);
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       reject(error);
    //     });
    // });
    // return promise;
  }
  getCurrentDayRunningTrip(tomorrow, today) {
    const tablename = TableConstants.ScTripMaster;
    // Use 'like' for contains/partial match on scheduled_date
    const endpoint = `${url}/${tablename}?data->>scheduled_date=like.*${today}*`;
    return this.httpUtils.get(endpoint);
  }
  getScUserTripByDriverAll(scheduled_date) {
    const tablename = TableConstants.ScUserTrip;
    const endpoint = `${url}/${tablename}?data->>scheduled_date=like.*${scheduled_date}*`;
    return this.httpUtils.get(endpoint);
  }
  getUserTripByDriverId(trip_id, driver_id) {
    const tablename = TableConstants.ScUserTrip;
    const endpoint = `${url}/${tablename}?trip_id=eq.${trip_id}&user_id=eq.${driver_id}`;
    return this.httpUtils.get(endpoint);
  }
  getScUserTripUser(trip_id) {
    const tablename = TableConstants.ScUserTrip;
    const endpoint = `${url}/${tablename}?trip_id=eq.${trip_id}`;
    return this.httpUtils.get(endpoint);
  }

  getScUserTripUserId(trip_id, user_id, scheduled_date) {
    const tablename = TableConstants.ScUserTrip;
    const endpoint = `${url}/${tablename}?trip_id=eq.${trip_id}&user_id=eq.${user_id}&data->>scheduled_date=eq.${scheduled_date}`;
    return this.httpUtils.get(endpoint);
  }
  getScUserTipByTripId(trip_id) {
    const tablename = TableConstants.ScUserTrip;
    const endpoint = `${url}/${tablename}?trip_id=eq.${trip_id}`;
    return this.httpUtils.get(endpoint);
  }

  getScUserTipByTripIdAllFields(trip_id) {
    const tablename = TableConstants.ScUserTrip;
    const endpoint = `${url}/${tablename}?trip_id=eq.${trip_id}`;
    return this.httpUtils.get(endpoint);
  }

  getScUserTripId(trip_id) {
    const tablename = TableConstants.ScUserTrip;
    const endpoint = `${url}/${tablename}?trip_id=eq.${trip_id}`;
    return this.httpUtils.get(endpoint);
  }

  getScUserTripByTripId(trip_id) {
    const tablename = TableConstants.ScUserTrip;
    const endpoint = `${url}/${tablename}?trip_id=eq.${trip_id}`;
    return this.httpUtils.get(endpoint);
  }

  getRncUsers(id) {
    if (id !== null) {
      const tablename = TableConstants.RncUsers;
      const endpoint = `${url}/${tablename}?id=eq.${id}`;
      return this.httpUtils.get(endpoint);
    } else {
      console.log("Invalid user_id - null or undefined provided");
      return Promise.resolve([]);
    }
  }
  getRncUsersByIds(ids: string[]): Promise<any[]> {
    if (Array.isArray(ids) && ids.length > 0) {
      const tablename = TableConstants.RncUsers;
      // Join IDs with commas for the 'in' filter
      const idList = ids.map(encodeURIComponent).join(',');
      const endpoint = `${url}/${tablename}?id=in.(${idList})`;
      return this.httpUtils.get(endpoint);
    } else {
      console.log("Invalid ids array provided to getRncUsersByIds");
      return Promise.resolve([]);
    }
  }
  SearchRncUsers(searchFilter: any, offset: number, limit: number) {
    const tablename = TableConstants.RncUsers;
    let endpoint = `${url}/${tablename}?`;
    const params: string[] = [];

    if (searchFilter.user_name && searchFilter.user_name !== "") {
      params.push(`data->>user_name=eq.${searchFilter.user_name}`);
    }

    if (searchFilter.user_type && searchFilter.user_type !== "") {
      params.push(`data->>user_type=eq.${searchFilter.user_type}`);
    }

    // params.push(`offset=${offset}`);
    // params.push(`limit=${limit}`);

    endpoint += params.join("&");
    return this.httpUtils.get(endpoint);
  }
  /* ############### DRIVER MODULE ################### */
  getDriverList(): Promise<any> {
    const tablename = TableConstants.CpDriverMaster;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  getDriverListbyPid(pid: string): Promise<any> {
    const tablename = TableConstants.CpDriverMaster;
    const endpoint = `${url}/${tablename}?data->>user_pid=eq.${pid}`;
    return this.httpUtils.get(endpoint);
  }
  CreateDriverData(driverData): Promise<any> {
    const tablename = TableConstants.CpDriverMaster;
    const endpoint = `${url}/${tablename}`;
    const payload = {
      user_pid: driverData.user_pid,
      data: {
        driver_name: driverData.driver_name,
        date_of_birth: driverData.date_of_birth,
        driving_license_no: driverData.driving_license_no,
        license_exp_date: driverData.license_exp_date,
        vendor_name: driverData.vendor_name,
        is_active: driverData.is_active,
        is_assigned: driverData.is_assigned,
        ex_data: driverData.ex_data,
        created_date: new Date().toISOString(),
        updated_date: new Date().toISOString(),
      },
      created_date: new Date().toISOString(),
      updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  UpdateDriverData(driverData): Promise<any> {
    const functionName = TableConstants.fnUpdateDriverData;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: driverData.id,
      p_user_pid: driverData.user_pid,
      updates: {
        driver_name: driverData.driver_name,
        date_of_birth: driverData.date_of_birth,
        driving_license_no: driverData.driving_license_no,
        license_exp_date: driverData.license_exp_date,
        vendor_name: driverData.vendor_name,
        is_active: driverData.is_active,
        is_assigned: driverData.is_assigned,
        ex_data: driverData.ex_data,
        created_date: driverData.created_date,
        updated_date: driverData.updated_date,
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  deleteDriverData(id: String): Promise<any> {
    const tablename = TableConstants.CpDriverMaster;
    const endpoint = `${url}/${tablename}?id=eq.${id}`;
    return this.httpUtils.delete(endpoint);
  }

  getDriverFeedbackList(): Promise<any> {
    const tablename = TableConstants.CpDriverFeedback;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  updateDriverFeedbackStat(id: String, status: string): Promise<any> {
    const functionName = TableConstants.fnUpdateDriverFeedbackStat;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: id,
      updates: {
        ex_data: status,
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  getDriverConcernList(): Promise<any> {
    const tablename = TableConstants.CpDriverConcern;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }

  updateDriverConcernStat(concernData): Promise<any> {
    const functionName = TableConstants.fnUpdateDriverConcernStat;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: concernData.id,
      updates: {
        comments: concernData.comments,
        request_status: concernData.request_status,
        sla_date: concernData.sla_date,
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload).then((response) => {
      return response[0];
    });
  }

  getAssignedDriverList(): Promise<any> {
    const tablename = TableConstants.CpAssignedDriver;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils.get(endpoint);
  }
  CreateDriverAssignData(driverAssignData): Promise<any> {
    const tablename = TableConstants.CpAssignedDriver;
    const endpoint = `${url}/${tablename}`;
    const payload = {
      driver_id: driverAssignData.driver_id,
      user_pid: driverAssignData.user_pid,
      data: {
        assigned_date: driverAssignData.assigned_date,
        end_date: driverAssignData.end_date,
        //driver_id: driverAssignData.driver_id,
        username: driverAssignData.username,
        //user_pid: driverAssignData.user_pid,
        status: driverAssignData.status,
        ex_data: driverAssignData.ex_data,
        created_date: driverAssignData.created_date,
        updated_date: driverAssignData.updated_date,
      },
      created_date: new Date().toISOString(),
      updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }
  UpdateDriverAssignData(driverAssignData): Promise<void> {
    const functionName = TableConstants.fnUpdateDriverAssignData;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: driverAssignData.id,
      p_driver_id: driverAssignData.driver_id,
      p_user_pid: driverAssignData.user_pid,
      updates: {
        assigned_date: driverAssignData.assigned_date,
        end_date: driverAssignData.end_date,
        driver_id: driverAssignData.driver_id,
        username: driverAssignData.username,
        user_pid: driverAssignData.user_pid,
        status: driverAssignData.status,
        ex_data: driverAssignData.ex_data,
        updated_date: driverAssignData.updated_date,
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  rnUserFilterById(userid: String): Promise<any> {
    const tablename = TableConstants.RncUsers;
    const endpoint = `${url}/${tablename}?id=eq.${userid}`;
    return this.httpUtils.get(endpoint);
  }

  /* ############### DRIVER MODULE ################### */

  getMiscData(data_key: string): Promise<any> {
    const tablename = TableConstants.MiscData;
    const endpoint = `${url}/${tablename}?data->>data_key=eq.${data_key}`;
    return this.httpUtils.get(endpoint);
  }

  updateMiscData(
    id: string,
    data_key: string,
    data_value: string
  ): Promise<any> {
    const functionName = TableConstants.fnUpdateMiscData;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: id,
      updates: {
        data_key: data_key,
        data_value: data_value,
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils.post(endpoint, payload);
  }

  private TAG = "AwsLoginCredentialsProvider";
  private QUERY_KEY = {
    UPDATE_USERS: AppConstants.update + environment.dbPrefix + "RncUsers",
  };
  private UpdateIsTempPassword =
    `mutation ` +
    this.QUERY_KEY.UPDATE_USERS +
    `($id: ID!, $password: String, $is_temporary_password: String) {
` +
    this.QUERY_KEY.UPDATE_USERS +
    `(input:{id: $id, password: $password, is_temporary_password: $is_temporary_password }) {
  id
  password
  is_temporary_password
}
}`;
  updateIsTempPassword(
    id: string,
    password: string,
    is_temporary_password: string
  ): Promise<boolean> {
    const functionName = TableConstants.fnUpdateIsTempPassword;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: id,
      updates: {
        password: password,
        is_temporary_password: is_temporary_password,
        updated_date: new Date().toISOString(),
      },
      p_updated_date: new Date().toISOString(),
    };
    return this.httpUtils
      .post(endpoint, payload)
      .then((response) => !!response);
  }

  deleteUserData(id: String): Promise<any> {
    const tablename = TableConstants.CpRnUser;
    const endpoint = `${url}/${tablename}?id=eq.${id}`;
    return this.httpUtils.delete(endpoint);
  }
}
